import {
  AccordionItem,
  AccordionTrigger,
  Box,
  Button,
  Typography,
} from '@branch-messenger/willow-ui'
import styled, { css } from 'styled-components'

import { largeTabletAndDown, largeTabletAndUp } from '@/styles/media'

export const HeaderComponentContainer = styled(Box).attrs({
  $display: 'flex',
  $align: 'center',
  $justify: 'space-between',
  $fullWidth: true,
  $gap: 8,
})`
  ${largeTabletAndDown(css`
    flex-direction: column;
    align-items: initial;
  `)}
`

export const HeaderDivider = styled(Box)`
  width: 1px;
  height: 30px;
  background-color: ${({ theme }) => theme.colors.gray};
`

export const AdvanceInfoContainer = styled(Box).attrs({
  $display: 'flex',
  $align: 'center',
  $justify: 'center',
  $gap: 8,
})`
  margin-left: auto;
  ${largeTabletAndDown(css`
    flex-direction: column;
    margin: 0;
    gap: ${({ theme }) => theme.space[2]};
  `)}
`

export const AdvanceInfoList = styled(Box).attrs({
  $display: 'flex',
  $align: 'initial',
  $gap: 8,
  $p: 0,
  as: 'ul',
})`
  margin-left: auto;

  ${largeTabletAndDown(css`
    width: 100%;
    justify-content: space-around;
    align-items: center;
    border: 1px solid ${({ theme }) => theme.colors.gray};
    padding: ${({ theme }) => `${theme.space[4]} ${theme.space[6]}`};
    border-radius: 104px;
    gap: 0;
    margin: 0 auto;
    max-width: 600px;
    flex-wrap: wrap;
  `)}

  @media only screen and (max-width: 375px) {
    padding: 0;
    border: none;
    gap: 0.25rem;
    align-items: start;
  }
`

export const AdvanceInfoItemContainer = styled(Box).attrs({
  $display: 'flex',
  $justify: 'center',
  $gap: 2,
  as: 'li',
})``

export const AdvanceInfoItemText = styled(Typography)`
  text-align: center;
`

export const AdvanceInfoItemDivider = styled(Box)`
  width: 1px;
  height: 38px;
  background-color: ${({ theme }) => theme.colors.gray};
  transform: rotate(16deg);
  transform-origin: center;

  ${largeTabletAndUp(css`
    display: none;
  `)}

  @media only screen and (max-width: 375px) {
    display: none;
  }
`

export const TakeAdvanceButton = styled(Button)`
  ${largeTabletAndDown(css`
    margin: 0 auto;
    width: 100%;
    max-width: 600px;
  `)}
`

export const AdvanceListItemDivider = styled(Box).attrs({ $mx: 6 })`
  height: 1px;
  background-color: ${({ theme }) => theme.colors.gray};
`

export const AdvanceListItemAccordionContent = styled(Box).attrs({
  $display: 'flex',
  $direction: 'column',
  $align: 'initial',
  $gap: 4,
  $pb: 4,
})``

export const AdvanceListAccordionItem = styled(AccordionItem)`
  margin-top: 0;
  &:last-child {
    ${AdvanceListItemDivider} {
      display: none;
    }
    ${AdvanceListItemAccordionContent} {
      padding-bottom: 0;
    }
  }
`

export const AdvanceListItemAccordionTrigger = styled(AccordionTrigger).attrs({
  $titleDivider: false,
})`
  gap: ${({ theme }) => theme.space[2]};
  padding: ${({ theme }) => theme.space[6]} ${({ theme }) => theme.space[6]};

  &:hover {
    background-color: ${({ theme }) => theme.colors.lightGray};
  }

  ${largeTabletAndDown(css`
    padding-left: ${({ theme }) => theme.space[4]};
    padding-right: ${({ theme }) => theme.space[4]};
  `)}
`
